import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import './notificationIcon.module.scss';
import { Link } from 'react-router-dom';
import { V3Routes } from '../../routes/index';
import { useNotificationIconState } from '../../contexts/notificationIcon';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';

const UnreadBadge = observer(() => {
  return <div styleName="unread-badge" data-image="unread-badge" />;
});

export const NotificationIcon = observer(() => {
  const currentUser = GlobalStatesV3.currentUser;
  const state = useNotificationIconState();

  useEffect(() => {
    if (currentUser.isSignedIn()) {
      state.init();
    }
  }, []);

  const notificationDeliveriesCount = state.notificationDeliveriesCount.value;

  if (currentUser.isSignedIn()) {
    return (
      <Link to={V3Routes.NotificationDeliveryListPage()}>
        <div styleName="notification-icon" data-image="notification-icon">
          {notificationDeliveriesCount > 0 && <UnreadBadge />}
        </div>
      </Link>
    );
  } else {
    return null;
  }
});

// SIDEナビゲーション用。リニューアルが終わったらNotificationIcon/UnreadBadgeコンポーネントは不要になるので削除。
export const NotificationUnreadBadge = observer(() => {
  const currentUser = GlobalStatesV3.currentUser;
  const state = useNotificationIconState();
  const notificationDeliveriesCount = state.notificationDeliveriesCount.value;

  useEffect(() => {
    if (currentUser.isSignedIn()) {
      state.init();
    }
  }, []);

  return <>{notificationDeliveriesCount > 0 && <div styleName="nav-unread-badge" data-image="nav-unread-badge" />}</>;
});
